import React, { useState, useEffect } from "react";

import SearchButton from "../../../components/buttons/search/search-btn";
import ConfirmDialog from "../../../components/actionDialogs/confirmDialog";
import CustomTable from "../../../components/table/table";
import "./view.css";
import CSVExport from "../../../components/csvExport";
import {
  get_manPowerList_list,
  admin_expman_delete,
  get_candidates_list,
  admin_cand_delete,
  admin_candidates_delete,
  admin_candidates_employed_list,
  admin_candidates_inactive_list,
  admin_candidates_deactivated_list,
} from "../admin.api";
import Loader from "../../../components/loader/loader";
import Snackbar from "../../../components/snackbar/snackbar";
import jwtDecode from "jwt-decode";
import moment from "moment";
import { useParams } from "react-router-dom/cjs/react-router-dom";
import * as XLSX from "xlsx";

export default function View(props) {
  const [data, setdata] = useState([]);
  const [view, setView] = useState(false);
  const [isActive, setIsActive] = useState(true);
  const [openAction, setOpenAction] = useState(false);
  const [activeData, setActiveData] = useState({});
  const [snackMessage, setSnackMessage] = useState("");
  const [isSnackError, setIsSnackError] = useState(false);
  const [snackOpen, setSnackOpen] = useState(false);
  let adminType = Number(jwtDecode(props.state.payload).user_type);
  const { id } = useParams();

  const handleAdviserList = () => {
    setIsActive(true);
    if (id === "registry") {
      get_candidates_list(adminType)
        .then((res) => {
          let tdata = res.data;
          let searchData = [];
          tdata.forEach((item, index) => {
            item["slno"] = index + 1;
            // searchData.push(data[0]?.);
          });
          setdata(tdata);
          setIsActive(false);
        })
        .catch(() => {
          setIsActive(false);
        });
    } else if (id === "employed") {
      admin_candidates_employed_list(adminType)
        .then((res) => {
          let tdata = res.data;
          let searchData = [];
          tdata.forEach((item, index) => {
            item["slno"] = index + 1;
            // searchData.push(data[0]?.);
          });
          setdata(tdata);
          setIsActive(false);
        })
        .catch(() => {
          setIsActive(false);
        });
    } else if (id === "inactive") {
      admin_candidates_inactive_list(adminType)
        .then((res) => {
          let tdata = res.data;
          let searchData = [];
          tdata.forEach((item, index) => {
            item["slno"] = index + 1;
            // searchData.push(data[0]?.);
          });
          setdata(tdata);
          setIsActive(false);
        })
        .catch(() => {
          setIsActive(false);
        });
    } else if (id === "optedout") {
      admin_candidates_deactivated_list(adminType)
        .then((res) => {
          let tdata = res.data;
          let searchData = [];
          tdata.forEach((item, index) => {
            item["slno"] = index + 1;
            // searchData.push(data[0]?.);
          });
          setdata(tdata);
          setIsActive(false);
        })
        .catch(() => {
          setIsActive(false);
        });
    } else {
      get_candidates_list(adminType)
        .then((res) => {
          let tdata = res.data;
          let searchData = [];
          tdata.forEach((item, index) => {
            item["slno"] = index + 1;
            // searchData.push(data[0]?.);
          });
          setdata(tdata);
          setIsActive(false);
        })
        .catch(() => {
          setIsActive(false);
        });
    }
  };
  const handleAddNew = (row) => {
    let path = `/manpower-add`;
    props.history.push(path);
  };

  const handleView = (data) => {
    let path = `/candidates-view/${data.id}/${id ?? "registry"}`;
    props.history.push(path);
  };

  const handleDelete = (data) => {
    setActiveData(data);
    setOpenAction(true);
  };
  const handleDeleteConfirm = (data) => {
    setOpenAction(false);
    setIsActive(true);
    admin_cand_delete(data.id)
      .then((res) => {
        setSnackMessage(res.message);
        setIsSnackError(false);
        setSnackOpen(true);
        setIsActive(false);
      })
      .catch((error) => {
        setSnackMessage(error.message);
        setIsSnackError(true);
        setSnackOpen(true);
        setIsActive(false);
      });
  };
  const snackbarClose = (flag) => {
    setSnackMessage("");
    setIsSnackError(false);
    setSnackOpen(false);
    if (!flag) {
      handleAdviserList();
    }
  };

  const handleDownload = () => { };
  const handleCancelDelete = () => {
    setOpenAction(false);
  };
  useEffect(() => {
    handleAdviserList();
  }, []);
  const handleInterest = (data) => {
    const input = data;
    const parsedArray = JSON.parse(input).map((item) => item.replace("/", " "));
    const result = parsedArray.join(", ");
    return result;
  };
  async function fetchExportData() {
    const exportdata = [];
    data.forEach((item, i) => {
      exportdata.push({
        "Sl no": i + 1,
        Name: item?.name,
        Phone: item?.contact,
        Email: item?.email,

        "Alternate Phone": item?.alt_contact,
        "Alternate Email": item?.alt_email,

        "Highest Qualification - Type": item?.education[0]?.edu_type_parent,
        "Highest Qualification":
          item?.education[0]?.edu_type_sub_one &&
            item?.education[0]?.edu_type_sub_one !== "Others"
            ? item?.education[0]?.edu_type_sub_one
            : item?.education[0]?.edu_type_others_text ?? "",
        "Highest Qualification - Stream": item?.education[0]?.edu_type_sub_two
          ? item?.education[0]?.edu_type_sub_two !== "Others"
            ? item?.education[0]?.edu_type_sub_two
            : item?.education[0]?.edu_type_others_text
          : "",
        "Highest Qualification - Percentage": item?.education[0]?.percentage,
        "Highest Qualification - Graduated in": item?.education[0]?.year,

        Experienced: item?.employment?.length !== 0 ? "Yes" : "No",

        Address: item?.address,
        "Registration Date": moment(item?.created_at).format("DD/MM/yyyy"),
        "Area of interest": item?.interest_type,
        Preferences: handleInterest(item?.interest),

        Status:
          item.status === 0
            ? "Pending"
            : item.status === 1
              ? "Submitted"
              : item.status === 2
                ? "Approved"
                : item.status === 3
                  ? "Reverted to user"
                  : item.status === 4
                    ? "Reverted to admin"
                    : item.status === 5
                      ? "Rejected"
                      : item.status === 9
                        ? "Deactivated"
                        : item.status === 7
                          ? "Deactivation Requested"
                          : "",
      });
    });
    return exportdata;
  }
  async function fetchExportBasicData() {
    const exportdata = [];
    data.forEach((item, i) => {
      exportdata.push({
        "Sl no": i + 1,
        Name: item?.name,
        Phone: item?.contact,
        Email: item?.email,

        "Alternate Phone": item?.alt_contact,
        "Alternate Email": item?.alt_email,
        Status:
          item.status === 0
            ? "Pending"
            : item.status === 1
              ? "Submitted"
              : item.status === 2
                ? "Approved"
                : item.status === "3"
                  ? "Joined Successfully"
                  : item.status === "4"
                    ? "Payment Done"
                    : item.status === 5
                      ? "Rejected"
                      : item.status === 9
                        ? "Deactivated"
                        : item.status === 7
                          ? "Deactivation Requested"
                          : "",
      });
    });
    return exportdata;
  }

  const downloadExcel = async () => {
    // const exportData = await fetchExportData();
    let exportData = [];

    if (id === "employed") {
      exportData = await fetchExportBasicData();
    } else {
      exportData = await fetchExportData();
    }

    if (!exportData.length) {
      setSnackMessage("No data to export");
      setIsSnackError(true);
      setSnackOpen(true);
      return;
    }

    const worksheet = XLSX.utils.json_to_sheet(exportData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Job Seekers");

    const fileName =
      (id === "registry"
        ? "Job_Seeker_Registry"
        : id === "employed"
          ? "Job_Seekers_Employed"
          : id === "inactive"
            ? "Inactive_Job_Seekers"
            : id === "optedout"
              ? "Opted_Out_Job_Seekers"
              : "Job_Seeker_Data") + ".xlsx";

    XLSX.writeFile(workbook, fileName);
  };

  return (
    <div>
      <Loader open={isActive} />
      <Snackbar
        message={snackMessage}
        error={isSnackError}
        open={snackOpen}
        close={snackbarClose}
      />
      <div className="view-container">
        {/* <h6>
          <b>Expert Manpower</b>
        </h6> */}
        <div className="d-flex justify-content-between align-items-center">
          <h6 className="m-0">
            <b>
              {id === "registry"
                ? "Job Seeker Registry"
                : id === "employed"
                  ? "Directory of Job Seekers Employed through KSPACE"
                  : id === "inactive"
                    ? "Directory of Inactive Job Seeker Registrations"
                    : id === "optedout"
                      ? "Directory of Job Seekers Opted-Out"
                      : ""}
            </b>
          </h6>
          <button
            className="px-2 py-2 search-style border-0 text-white rounded"
            onClick={downloadExcel}
          >
            Download Excel
          </button>
        </div>
        <hr />
        {/* ---------admin--------------- */}
        {(adminType === 1 || adminType === 23) && (
          <>
            {/* <button
              type="button"
              className="btn btn-primary btn-sm"
              onClick={(e) => handleAddNew(e)}
            >
              Add New
            </button> */}
            {/* <div className="row font-z mt-2">
              <div className="col-3 ">
                <select className="form-select" aria-label="Default select example">
                  <option selected>Select Application Status</option>
                  <option value="1">Pending</option>
                  <option value="2">Accepted</option>
                </select>
              </div>
              <div className="col-1 d-flex">
                <SearchButton {...props} onClick={onSearch} />
              </div>
            </div> */}
            <CustomTable
              {...props}
              columns={[
                { title: " Name", field: "name" },
                { title: "Email", field: "email" },
                { title: "Phone Number", field: "contact" },
                {
                  title: "Updated at",
                  field: "updated_at",
                  type: "fullDateTime",
                },
                // { title: "Area of Expertise", field: "category" },
                ...[
                  id === "employed"
                    ? {
                      title: "Status",
                      field: "status",
                      type: "downloadedStatus",
                    }
                    : {
                      title: "Status",
                      field: "status",
                      type: "candidatesList",
                    },
                ],
              ]}
              data={data}
              actions={[
                { type: "view", handleClick: handleView },
                // { type: "edit", handleClick: handleEdit },
                // { type: "delete", handleClick: handleDelete },
              ]}
            />
          </>
        )}
        {/* -------------super admin------ */}
        {adminType === 2 && (
          <>
            {/* <div className="row font-z"> */}
            {/* <div className="col-3 ">
                <select className="form-select" aria-label="Default select example">
                  <option selected>Select Application Status</option>
                  <option value="1">Pending</option>
                  <option value="2">Accepted</option>
                </select>
              </div>
              <div className="col-1 d-flex">
                <SearchButton {...props} onClick={onSearch} />
              </div>
            </div> */}
            <CustomTable
              {...props}
              columns={[
                { title: " Name", field: "name" },
                { title: "Email", field: "email" },
                { title: "Phone Number", field: "contact" },
                {
                  title: "Updated at",
                  field: "updated_at",
                  type: "fullDateTime",
                },
                // { title: "Area of Expertise", field: "category" },

                ...[
                  id === "employed"
                    ? {
                      title: "Status",
                      field: "status",
                      type: "downloadedStatus",
                    }
                    : {
                      title: "Status",
                      field: "status",
                      type: "candidatesList",
                    },
                ],
              ]}
              data={data}
              actions={[
                { type: "view", handleClick: handleView },
                { type: "delete", handleClick: handleDelete },
              ]}
            />
          </>
        )}
        {/* -------------super admin------ */}
      </div>
      {openAction && (
        <ConfirmDialog
          open={openAction}
          title="Delete Job Seeker ?"
          data={activeData}
          message="Are you sure to delete this Job Seeker?"
          secondary_action="Cancel"
          primary_action="Delete"
          handleClose={handleCancelDelete}
          handleConfirm={handleDeleteConfirm}
        />
      )}
    </div>
  );
}
